import React from "react";
import PersonAdaptToClient from "@parts/person/personAdaptToClient";
import { checkIfBranchExists } from "../../../../utils";
export default class CreateClient extends React.Component {
  constructor(props) {
    super(props);
    checkIfBranchExists()
    this.state = {};
    this.save = this.save.bind(this);
  }
  save(client) {
    window.location.href = "/clients";
  }

  UNSAFE_componentWillMount() {}
  render() {
    return <PersonAdaptToClient onSaveClient={this.save} />;
  }

  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/create/index.jsx